import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from "../../components/common/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";

import Footer from "../../components/common/Footer";
import { useState, useRef } from "react";
import { getCateListAction} from "../../modules/common/cateModule";
import { forEach, find, indexOf, uniq, remove} from 'lodash';
import MyEsOrderBox from '../../components/es/MyEsOrderBox';
import { isIE, isChrome, isMobileOnly , isIOS} from "react-device-detect";
import { useHistory } from 'react-router-dom';
import {parseQueryString,buildQueryString, isEmptyObject} from "../../lib/util/CommonFunctions";
import CateAnimate from '../../components/ct/CateAnimate';
import TagBtnMy from '../../components/common/button/TagBtnMy';
import { getProdFilterInfoAction, getCategoryFilterInfoAction,resetCountPriceAction, getCategoryCountFromPriceInfoAction } from '../../modules/common/prodModule';
import queryString from "query-string";
import ProdItem2 from '../../components/common/prod/ProdItem2';
import PaginationMobile from "../../components/common/PaginationMobile";
import Pagination from "../../components/common/Pagination";
import CateFilterPopup from '../../components/ct/CateFilterPopup';
import CategoryPopup from '../../components/ct/CategoryPopup';

const CategoryBlock = styled.div`
    .paging-bottom {
        margin-bottom: ${isMobileOnly?'60px':'160px'};
    }
`;

const CategoryContentsBlock = styled.div`
    ${isMobileOnly?`  
    margin: 0 4vw;
    padding-top: 60px;
    `:`
    max-width: 1176px;
    width: 100%;
    margin: 0 auto;
    padding-top: 80px;
    `};
`;

const CategoryLeftBlock = styled.div`
    float: left;
    width: 220px;
    margin-top: 40px;

    .title {
        font-size: 22px;
        font-weight: 500;
        line-height: 1.75;
        color: #111111;
        cursor: pointer;
    }
`;

const CategoryRightBlock = styled.div`
    float: right;
    width: 875px;
    margin-top: 40px;
`;

const CategoryBreadBlock = styled.div`
    display:${props => props.display||'none'};
    font-size: 12px;
    line-height: 1.5;
    ${isMobileOnly?`  
    margin-top: 16px;
    margin-bottom: 16px;
    `:`
    margin-bottom: 20px;
    `};
    

    .bread {
        color: #999999;
        position: relative;
        ::after {
            content: '';
            display: inline-block;
            width: 6px;
            height: 9px;
            background: url(/assets/images/icon/cate-bread.png)  center center/auto no-repeat;
            margin: 0 6px;
            background-size: 6px 9px;
        }
    }

    .no-bread {
        color: #333333;
    }

    .active {
        cursor: pointer;
    }
`;

const CategoryFilterBlock = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    width: 100vw;   
    margin-top: 20px;
    margin-bottom: 10px;
    `:`
    width: 100%;
    //margin-top: 18px;
    margin-bottom: 20px;
    `};
    
    //overflow: scroll hidden;
    
    position: relative;
    

    .rConatiner {
        ${isMobileOnly?`
        width: calc(100vw - 70px);  
        overflow: scroll;
        `:`
        width: calc(100% - 70px);
        width: 795px;
        overflow: auto;
        `};
        
        position: relative;
    }

    .container {
        ${isMobileOnly?`
        width: max-content;
        padding-right: 20px;
        //padding-bottom: 10px;
        `:`
        //display: flex;
        //white-space: nowrap;
        `};
        
        
    }

    .rConatiner::-webkit-scrollbar {
        ${isMobileOnly?`
         
        `:`
        height: 4px
        `};
        
      }

    .rConatiner::-webkit-scrollbar-thumb {
        ${isMobileOnly?`
         
        `:`
        border-radius: 2px;
        background-color: #ececec;
        `};
        
      }

    .default {
        height: 24px;
        padding: 3px 12px;
        border-radius: 13px;
        background-color: #f4f4f4;

        font-size: 12px;
        font-weight: normal;
        color: #999999;

        margin-right: 6px;
        //margin-bottom: 10px;
        float: left;
        ${isMobileOnly?`
        margin-bottom: 10px;
        `:`
        flex: 0 0 auto;
        `};
    }

    .default:last-child {
        //margin-right: 4vw;
    }

    .default:first-child {
        ${isMobileOnly?`
        margin-left: 4vw; 
        `:`

        `};
    }

    .top-cate {
        margin-right: 6px;
        float: left;
        margin-bottom: 10px;
    }

    .top-cate:first-child {
        ${isMobileOnly?`
        margin-left: 4vw; 
        `:`

        `};
    }

    .orderbox {
        position: absolute;
        top: 0px;
        right: 0px;
        height: 24px;
        background-color: #ffffff;
        width: auto;
        padding-left: 10px;
        
        ${isMobileOnly?`
        padding-right: 4vw;
        `:`

        `};
    }
`;

const CategoryProductBlock = styled.div`
    ${isMobileOnly?`
    width: 92vw;
    `:`

    `};
`;

const ProdItemListUlBlock = styled.ul`
/*JP*/
    display: flex;
    flex-wrap: wrap;
    justify-content: ${isMobileOnly?'space-between':'flex-start'};
/*JP*/    
    ${isMobileOnly?"margin-left:0":"margin-left: -28px"};
    //margin-bottom: 80px;

    ::-webkit-scrollbar {
        width: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }

    ::-webkit-scrollbar-track {
        background-color: #f4f4f4;
    }

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const ProdItemNoItemBloc = styled.div`
    position: relative;
    height: 180px;
`;

const ProdItemNoItemSpanBlock = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #666;
    font-size: 16px;
`;

const CategoryPopBgContainer = styled.div`
    ${isMobileOnly?`
    //margin-left: -4vw;
    `:`

    `};
    position: fixed;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100vw;
    height: 100vh;
    z-index: 50;
    
    display: none;
    bottom: 0;
`;

const CategoryPopContainer = styled.div`
    ${isMobileOnly?`
    //margin-left: -4vw;
    `:`
    
    `};
`;

const CategoryMHeaderBlock = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;

    .gnb {
        display:${props => props.gnb||'block'};
        height: 60px;
    }

    .cate {
        display:${props => props.cate||'none'};
        height: 50px;
        font-size: 16px;
        font-weight: 500;
        color: #111111;
        text-align: center;
        line-height: 50px;
        width: 100vw;
        background-color: #ffffff;

    }

    .active {
        display: block;
    }

    .no-active {
        display: none;
    }
`;

const CategoryMCategoryBlock = styled.div`

`;

const CategoryM1stBlock = styled.div`
    width: 100vw;
    margin-left: -4vw;
    overflow: scroll;
    position: relative;
    background-color: #f4f4f4;
    padding: 10px 0;

    .container {
        width: max-content;
    }

    .cate-1st:last-child {
        margin-right: 4vw;
    }
    .cate-1st:first-child {
        margin-left: 4vw;
    }
`;

const CategoryM2ndBlock = styled.div`
    -webkit-text-size-adjust: none;
    width: 100vw;
    margin-left: -4vw;
    overflow: scroll;
    position: relative;
    font-size: 14px;
    padding: 10px 0;

    .container {
        width: max-content;
    }

    .cate-2nd:last-child {
        margin-right: 4vw;
    }
    .cate-2nd:first-child {
        margin-left: 4vw;
    }
`;

const CategoryM1stCateItem = styled.span`
//width: fit-content;
    position: relative;
    //display: inline;
    color: ${props => props.isActive ? '#fd683a' : '#999999'};
    font-size: 14px;
    line-height: 1.43;
    cursor: pointer;
    margin-left: 10px;
    
    &:after {
        content: '';
        display: ${props => props.isActive ? 'block' : 'none'};
        position: absolute;
        width: ${props => props.isActive ? '100%' : '0%'};
        left: 0;
        bottom: ${props => props.bottom || '-10px'};
        height: ${props => props.height || '2px'};
        //background-color: #79b88a;
        //background-color: ${isMobileOnly?"#111111":"#79b88a"};
        background-color: #fd683a;
        //z-index: -1;
        -webkit-transition: width .2s ease-in;
        -o-transition: width .2s ease-in;
        transition: width .2s ease-in;
    }

    &:hover::after {
        width: 100%;
    }
`;

const CategoryM2ndCateItem = styled.span`

//width: fit-content;
    position: relative;
    //display: inline;
    
    font-size: 14px;
    line-height: 1.43;
    cursor: pointer;
    margin-left: 20px;
    //padding: 10px 0;
    color: ${props => props.isActive ? '#111111' : '#cccccc'};
`;

const Options = [
    { value: 0, label: "인기순" },
    { value: 1, label: "최신순" },
    { value: 2, label: "높은가격순" },
    { value: 3, label: "낮은가격순" },
];

const SLIDE_DURATION = 150;
const STICK_DURATION = 300;

const Category = ({ match, location }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [firstCateId, setFirstCateId] = useState(0);
    const [secondCateId, setSecondCateId] = useState(0);
    const [curPrice, setCurPrice] = useState([0, 0]);
    const [maxPrice, setMaxPrice] = useState([0, 0]);
    const [arrCateId, setArrCateId] = useState([]);
    const [arrFilter, setArrFilter] = useState([]);
    const [isDefault, setIsDefault] = useState(false);
    const [pIndex, setPIndex] = useState(0);
    const [curPage, setCurPage]=useState(1);
    const [popup, setPopup] = useState(false);
    const [popupCate, setPopupCate] = useState(false); 
    const [order,setOrder] = useState(0);
    const [selCateId, setSelCateId] = useState(-1);
    const refGnb = useRef(null);
    const refCate = useRef(null);
    const reflimit = useRef(null);
    const [prevOffset, setPrevOffset] = useState(0);

    const { categoryItems, error, loading, curMenu, prodItems, categoryFilterInfo , esCountProdFromFilter} = useSelector(
        ({ cateItemsReducer, loadingReducer, headerReducer, prodItemsReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            error: cateItemsReducer.error,
            loading: loadingReducer['cate/LIST_CATE'],
            curMenu: headerReducer.curMenu,
            prodItems: prodItemsReducer.prodItems,
            categoryFilterInfo: prodItemsReducer.categoryFilterInfo,
            esCountProdFromFilter: prodItemsReducer.esCountProdFromFilter,
        })
    );

    useEffect(() => {
        if (curMenu !== 'ct') {
            window.scrollTo(0, 0);
            dispatch(setCurMenuAction('ct'));
            dispatch(setHeaderTransferAction(false));
        }

        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {

        if (categoryItems === null) {
            dispatch(getCateListAction());
        }

    }, [categoryItems]);

    useEffect(() => {

        if (categoryFilterInfo !== null && categoryFilterInfo !== undefined) {
            let minPrice = Math.floor(categoryFilterInfo.aggregations.minprice.value / 10000) * 10000;
            let maxPrice = Math.floor(categoryFilterInfo.aggregations.maxprice.value / 10000) * 10000;// + 10000;

            if (maxPrice === categoryFilterInfo.aggregations.maxprice.value) {

            }
            else {
                maxPrice += 10000;
            }
            setMaxPrice([minPrice, maxPrice]);
            let query = queryString.parse(location.search);
            if(query && query.price && query.price !== undefined){

            } else {
                setCurPrice([minPrice*1, maxPrice*1]);
            }
        }

    }, [categoryFilterInfo, location]);

    useEffect(() => {
        parseUrl(location, match);
    }, [location, match]);

    useEffect(() => {
        if(esCountProdFromFilter) {
            let query = queryString.parse(location.search);
            if(query && query.cate3Ids && query.cate3Ids !== undefined) {
                let cateData = [];
                let cate3Ids = query.cate3Ids.split(',');
                forEach(cate3Ids, (curobj, index) => {
                    if(esCountProdFromFilter&&esCountProdFromFilter.cateItem&&esCountProdFromFilter.cateItem.cate_count&&esCountProdFromFilter.cateItem.cate_count.buckets!==undefined) {
                        forEach(esCountProdFromFilter.cateItem.cate_count.buckets, (cateitem, index) => {
                            if(cateitem.key*1 === curobj*1) {
                                let catenames = cateitem.cate_key.buckets[0].key.split(' > ');
                                let data = {};
                                data.id = curobj*1;
                                data.name = catenames[2];
                                cateData.push(data);
                            }
                            
                        });
                    }
                });
                if(cateData&&cateData.length>0){
                    setArrCateId(cateData);
                }
                
            } else {
                setArrCateId([]);
            }
        }
        //let query = queryString.parse(location.search);
    }, [location, esCountProdFromFilter]);

    useEffect(() => {

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);

    }, [prevOffset]);

    const onScroll = () => {
        
        if(isMobileOnly&&refCate.current&&refGnb.current&&reflimit.current) {

            if(isIOS&&document.body.style.top) {
                return;
            }

            if(window.scrollY > reflimit.current.offsetTop - 60) {
                refCate.current.classList.add('active');
            } else {
                refCate.current.classList.remove('active');
            }
    
            let scrollY = window.scrollY;
            let y = Math.abs(prevOffset-window.scrollY);
           
           if (scrollY > prevOffset && y>10) {
               //setScrollDirection("down")
               if(window.scrollY > reflimit.current.offsetTop - 60) {
                refGnb.current.classList.add('no-active');
               }
               
           } else if (scrollY < prevOffset && y>10) {
               //setScrollDirection("up")
               refGnb.current.classList.remove('no-active');
           }
    
           if (scrollY === 0) {
                refCate.current.classList.remove('active');
                refGnb.current.classList.remove('no-active');
            }
    
            setPrevOffset(window.scrollY);
        }
        
    };

    const makeUrl = (cate1Id, cate2Id, filter, cate3Ids, curprice, brandIds, curpage, sort) => {
        let url = "/ct";
        let params = [];

        if(cate1Id*1 > 0) {
            if(cate2Id*1 > 0) {
                let cate = cate1Id*100 + cate2Id;
                url += "/" + cate;
            } else {
                url += "/" + cate1Id;
            }
        }

        let cateid = [];
        forEach(cate3Ids, (curobj, index) => {
            cateid.push(curobj.id);
        });

        if(filter && filter.length>0) {
            params.push('filter='+filter.join(','));
        }
        if(cateid && cateid.length>0) {
            params.push('cate3Ids='+cateid.join(','));
        }
        if(curprice && curprice.length>0 && curprice[1] > 0) {

            if(maxPrice[0]*1 === curprice[0]*1 && maxPrice[1]*1 === curprice[1]*1)
            {

            } else {
                params.push('price='+curprice.join(','));
            }
        }
        
        if(curpage && curpage > 0) {
            params.push('page='+curpage);
        }
        if(sort && sort >= 0) {
            params.push('sort='+sort);
        }

        //console.log("params = " + JSON.stringify(params))
        if(params && params.length > 0) {
            url += "?" + params.join('&');
        }

        //console.log("url = " + url);

        return url;
    }

    const parseUrl = (location, match) => {
        let query = queryString.parse(location.search);
        let cate1Id = 0;
        let cate2Id = 0;
        let filter = [];
        let cate3Ids = [];
        let minprice = 0;
        let maxprice = 0;
        let curpage = 1;
        let sort = 0;
        let isDefault = true;

        //console.log("query = " + JSON.stringify(query))
        if(query && query.filter && query.filter !== undefined) {
            setArrFilter(query.filter.split(','));
            filter = query.filter.split(',');
            isDefault = false;
        } else {
            setArrFilter([]);
        }

        if(query && query.cate3Ids && query.cate3Ids !== undefined) {
            setArrCateId(query.cate3Ids.split(','));
            cate3Ids = query.cate3Ids.split(',');
            isDefault = false;
        } else {
            setArrCateId([]);
        }

        if(query && query.price && query.price !== undefined) {
            let price = query.price.split(',');
            setCurPrice([price[0]*1,price[1]*1]);
            minprice = price&&price.length>1? price[0]:0;
            maxprice = price&&price.length>1? price[1]:0;
            isDefault = false;
        } else {
            setCurPrice([0,0]);
            dispatch(resetCountPriceAction());
        }

        if(query && query.page && query.page !== undefined) {
            setCurPage(query.page);
            curpage = query.page;
        } else {
            setCurPage(1);
        }

        if(query && query.sort && query.sort !== undefined) {
            setOrder(query.sort*1);
            sort = query.sort*1;
        } else {
            setOrder(0);
        }

        
        setIsDefault(isDefault);

        if(match.params&&match.params.code){
            switch(match.params.code.length){
                case 4:
                    let cate1 = Math.floor(match.params.code / 100);
                    setFirstCateId(cate1);
                    cate1Id = cate1;

                    let cate2 = match.params.code%100;
                    setSecondCateId(cate2);
                    cate2Id = cate2;
                    
                    break;
                case 2:
                    let cate = Math.floor(match.params.code);
                    setFirstCateId(cate);
                    setSecondCateId(0);
                    cate1Id = cate;
                    break;
                default:
                    setFirstCateId(0);
                    setSecondCateId(0);
                    break;
            }
        } else {
            setFirstCateId(0);
            setSecondCateId(0);
        }

        dispatch(getProdFilterInfoAction(cate1Id, cate2Id, filter, cate3Ids, minprice, maxprice, [], curpage, sort, isMobileOnly,""));
        dispatch(getCategoryFilterInfoAction(cate1Id, cate2Id, [],""));
        if(cate2Id*1 === 0 && maxprice*1 >= 0) {
            dispatch(getCategoryCountFromPriceInfoAction(cate1Id,cate2Id,[], minprice,maxprice,""));
        }
        window.scrollTo(0, 0);
    }

    const getNavString = () => {
        let navString = ' ';

        if (categoryItems === null) {
            return;
        }

        if (!firstCateId) {
            return <span>전체</span>;
        } else {
            const targetCategory = categoryItems.filter(function (item) {
                return item.id === firstCateId
            });

            if (targetCategory !== null) {
                if (!secondCateId) {
                    return <span><span className="bread active" onClick={()=>handleBread(0)}>전체</span><span className="bread active" onClick={()=>handleBread(1)}>{targetCategory[0].cate_name}</span><span className="no-bread">전체</span></span>;
                } else {
                    let cate2 = targetCategory[0].cate2.filter((item) => {
                        return item.id === secondCateId % 100;
                    })
                    return <span><span className="bread active" onClick={()=>handleBread(0)}>전체</span><span className="bread active" onClick={()=>handleBread(1)}>{targetCategory[0].cate_name}</span><span className="no-bread">{cate2[0].cate_name}</span></span>;
                }
            }
        }
        return navString;
    }

    const handleBread = (index) => {
        if(index*1 === 0) {
            handleCateAll();
        } else {
            click1handler(firstCateId);
        }
    }

    const handleOptionClick = (value) => {
        let _index = 2;
        if(value === -100) { //브랜드
            _index=0;
        } else if(value === -10) { //가격
            _index=0;
        } else { //옵션
            _index=1;
        }

        setPIndex(_index);
        let value2 = true;
        setPopup(value2);
    }

    const handleOpenPopup = (index) => {
        let _index = index;
        setPIndex(_index);
        let value = true;
        setPopup(value);
    }

    const handleClosePopup = () => {
        setPopup(false);
        setPIndex(-1);
    }

    const handleOpenCatePopup = () => {
        let value = true;
        setPopupCate(value);
    }

    const handleCloseCatePopup = () => {
        setPopupCate(false);
    }

    const handlePriceDelClick = () => {
        let urlString = makeUrl(firstCateId, secondCateId, arrFilter, arrCateId, [0,0], [], -1, order);
        history.replace(urlString);
    }

    const handleCateDelClick = (cateid) => {
        let value = cateid*1;
        
        if(isNaN(value)) {
            let arr = [];
            Object.assign(arr, arrFilter);
            remove(arr, (obj) => {
                return (obj === cateid);
            });

            let urlString = makeUrl(firstCateId, secondCateId, arr, arrCateId, curPrice, [], -1, order);
            history.replace(urlString);

        } else {
            let arr = [];
            Object.assign(arr, arrCateId);
            remove(arr, (obj) => {
                return (obj.id*1 === cateid*1);
            });
            
            let urlString = makeUrl(firstCateId, secondCateId, arrFilter, arr, curPrice, [], -1, order);
            history.replace(urlString);
        }

    }

    const handlerChangeOrder = (value, width) => {
        setOrder(value.value);

        let urlString = makeUrl(firstCateId, secondCateId, arrFilter, arrCateId, curPrice, [], -1, value.value);
        history.replace(urlString);
    }

    const handleChangePageNum = (value) => {
        setCurPage(value);
        console.log("curprice = " + JSON.stringify(curPrice))
        let urlString = makeUrl(firstCateId, secondCateId, arrFilter, arrCateId, curPrice, [], value, order);
        history.push(urlString);
    }

    const handleReceiveFromPopup = (curPrice, arrCateId, arrFilter) => {
        
        //console.log("arrCateId = " + JSON.stringify(arrCateId))
        //console.log("arrFilter = " + JSON.stringify(arrFilter))
        let urlString = makeUrl(firstCateId, secondCateId, arrFilter, arrCateId, curPrice, [], -1, order);
        history.replace(urlString);
    }

    const handleReceiveFromCatePopup = (firstId, secondId) => {
        let urlString = makeUrl(firstId*1, secondId*1, [], [], [], [], -1, order);
        history.replace(urlString);
    }

    const getFilterOrderValue = () => {
        for (var i = 0; i < Options.length; i++) {
            if (order === Options[i].value) {
                return Options[i];
            }
        }
    }

    const click1handler = (id) => {
        setFirstCateId(id);
        setSecondCateId(0);
        let urlString = makeUrl(id, 0, [], [], [], [], -1, order);
        history.replace(urlString);
    }

    const click2Handler = (id) => {
        setSecondCateId(id);
        let urlString = makeUrl(firstCateId, id, [], [], [], [], -1, order);
        history.replace(urlString);
    }

    const handleCateAll = () => {
        setFirstCateId(0);
        setSecondCateId(0);
        let urlString = makeUrl(0, 0, [], [], [], [], -1, order);
        history.replace(urlString);
    }

    const handleProdClick = (prodinfo) => {
        history.push('/prod?prodid=' + prodinfo._source.prdct_id)
    }

    const click1Mhandler = (id) => {
        if(firstCateId*1 === id*1) {
            handleCateAll();
            return;
        }

        setFirstCateId(id);
        setSecondCateId(0);
        let urlString = makeUrl(id, 0, [], [], [], [], -1, order);
        history.replace(urlString);
    }

    const click2Mhandler = (id) => {
        if(secondCateId*1 === id*1) {
            return;
        }

        setSecondCateId(id);
        let urlString = makeUrl(firstCateId, id, [], [], [], [], -1, order);
        history.replace(urlString);
    }

    const getActive1st = (id) => {
        if(id*1 === firstCateId*1) {
            return true;
        }

        return false;
    }

    const getActive2nd = (id) => {
        if(id*1 === secondCateId*1) {
            return true;
        }

        return false;
    }

    const get2ndCate = () => {
        let cate2 = [];
        forEach(categoryItems, (cate1, index) => {
            if(cate1.id*1 === firstCateId*1) {
                cate2 = cate1.cate2;
            }
            
        });

        return cate2;
    }

    const getCateName = () => {
        let navString = ' ';

        if (categoryItems === null) {
            return;
        }

        if (!firstCateId) {
            return '전체';
        } else {
            const targetCategory = categoryItems.filter(function (item) {
                return item.id === firstCateId
            });

            if (targetCategory !== null) {

                if (!secondCateId) {
                    return targetCategory[0].cate_name;
                } else {
                    let cate2 = targetCategory[0].cate2.filter((item) => {
                        return item.id === secondCateId % 100;
                    })
                    return cate2[0].cate_name;
                }
            }
        }
        return navString;
    }

    if(categoryItems === null || categoryItems === undefined) {
        return <div/>
    }

    if (prodItems !== null && prodItems.dataList === undefined && prodItems.paging) {
        return (
            isMobileOnly?
        <CategoryBlock>
            <CategoryMHeaderBlock>
                <div className="gnb clearfix" ref={refGnb}>
                    <Header />
                </div>
                <div className="cate" ref={refCate}>
                    {getCateName()}<span style={{marginLeft:'8px'}}>+</span>
                </div>
            </CategoryMHeaderBlock>
            <CategoryContentsBlock className="clearfix">
                <CategoryMCategoryBlock>
                    <CategoryM1stBlock className="margin_b-10">
                        <div className="container">
                        {
                            categoryItems.map((curitem, idx) => {
                                return (
                                    <CategoryM1stCateItem className="cate-1st" isActive={getActive1st(curitem.id)}  onClick={()=>click1Mhandler(curitem.id)}>
                                        {curitem.cate_name}
                                    </CategoryM1stCateItem>
                                );
                            })
                        }
                        </div>
                    </CategoryM1stBlock>
                    <CategoryM2ndBlock style={{display: firstCateId*1>0? 'block':'none'}}>
                        <div className="container">
                            <CategoryM2ndCateItem className="cate-2nd" key={-1} isActive={getActive2nd(0)} onClick={()=>{click2Mhandler(0)}}>
                                                전체
                            </CategoryM2ndCateItem>
                                {
                                    get2ndCate().map((cate, idx) => {
                                        return (
                                            <CategoryM2ndCateItem className="cate-2nd" key={idx} isActive={getActive2nd(cate.id)} onClick={()=>{click2Mhandler(cate.id)}}>
                                                {cate.cate_name}
                                            </CategoryM2ndCateItem>
                                        
                                        );
                                    })
                                }
                        </div>
                    </CategoryM2ndBlock>
                </CategoryMCategoryBlock>
                <ProdItemNoItemBloc>
                <ProdItemNoItemSpanBlock>
                    상품이 없습니다.
                        </ProdItemNoItemSpanBlock>
                </ProdItemNoItemBloc>
            </CategoryContentsBlock>
            <Footer />
        </CategoryBlock>
        :
        <CategoryBlock>
            <Header />
            <CategoryContentsBlock className="clearfix">
                <CategoryLeftBlock>
                    <div className="title margin_b-30" onClick={handleCateAll}>카테고리</div>
                    {
                        categoryItems.map((curitem, idx) => {
                            return (
                                <CateAnimate key={idx} cateItem={curitem} active1stCateId={firstCateId} active2ndCateId={secondCateId} click1handler={click1handler} click2Handler={click2Handler}>
                                    
                                </CateAnimate>
                            );
                        })
                    }

                </CategoryLeftBlock>
                <CategoryRightBlock>
                <ProdItemNoItemBloc>
                    <ProdItemNoItemSpanBlock>
                        상품이 없습니다.
                    </ProdItemNoItemSpanBlock>
                </ProdItemNoItemBloc>
                </CategoryRightBlock>
            </CategoryContentsBlock>
            <CategoryPopBgContainer style={{display:popup? "block":'none'}}/>
            <CategoryPopContainer>
                <CateFilterPopup active={popup} handleClosePopup={handleClosePopup} pCate1Id={firstCateId} pCate2Id={secondCateId} pIndex={pIndex} handleReceiveFromPopup={handleReceiveFromPopup}
                _maxPrice={maxPrice} _curPrice={curPrice} brandId={[]} search=""/>
            </CategoryPopContainer>
            <Footer />
        </CategoryBlock>
        );
    }

    return (
        isMobileOnly?
        <CategoryBlock>
            <CategoryMHeaderBlock>
                <div className="gnb clearfix" ref={refGnb}>
                    <Header />
                </div>
                <div className="cate" ref={refCate} onClick={handleOpenCatePopup}>
                    {getCateName()}<span style={{marginLeft:'8px'}}>+</span>
                </div>
            </CategoryMHeaderBlock>
            <CategoryContentsBlock className="clearfix">
                <CategoryBreadBlock display={firstCateId*1>0 ? "block" : "none"}>{getNavString()}</CategoryBreadBlock>
                <CategoryMCategoryBlock>
                    <CategoryM1stBlock className="margin_b-10">
                        <div className="container">
                        {
                            categoryItems.map((curitem, idx) => {
                                return (
                                    <CategoryM1stCateItem key={curitem.id} className="cate-1st" isActive={getActive1st(curitem.id)}  onClick={()=>click1Mhandler(curitem.id)}>
                                        {curitem.cate_name}
                                    </CategoryM1stCateItem>
                                );
                            })
                        }
                        </div>
                    </CategoryM1stBlock>
                    <CategoryM2ndBlock style={{display: firstCateId*1>0? 'block':'none'}}>
                        <div className="container">
                            <CategoryM2ndCateItem className="cate-2nd" key={-1} isActive={getActive2nd(0)} onClick={()=>{click2Mhandler(0)}}>
                                                전체
                            </CategoryM2ndCateItem>
                                {
                                    get2ndCate().map((cate, idx) => {
                                        return (
                                            <CategoryM2ndCateItem className="cate-2nd" key={idx} isActive={getActive2nd(cate.id)} onClick={()=>{click2Mhandler(cate.id)}}>
                                                {cate.cate_name}
                                            </CategoryM2ndCateItem>
                                        
                                        );
                                    })
                                }
                        </div>
                    </CategoryM2ndBlock>
                </CategoryMCategoryBlock>
                <CategoryFilterBlock style={{marginTop:firstCateId*1>0 ? "8px":"20px"}}>
                    {
                            isDefault?
                            <div className="rConatiner" width={"765px"}>
                            <div className="container clearfix" >
                                
                                <button className="default" onClick={()=>handleOpenPopup(0)}>가격</button> 
                                {
                                    secondCateId*1>0&&<button className="default" onClick={()=>handleOpenPopup(1)}>옵션</button> 
                                }
                            </div>
                            </div>
                            :
                            <div className="rConatiner" width={"765px"}>
                            <div className="container clearfix" >
                                {
                                    (curPrice[0]*1!==maxPrice[0]*1||curPrice[1]*1!==maxPrice[1]*1)&&curPrice[1]>0&&<div className="top-cate">
                                    <TagBtnMy
                                        active={true}
                                        float='left'
                                        onClick={handleOptionClick}
                                        onDelClick={handlePriceDelClick}
                                        text={Number(curPrice[0].toFixed(1)).toLocaleString()+'원~'+ Number(curPrice[1].toFixed(1)).toLocaleString()+'원'} isSmall={true} value={-10}
                                    />
                                    </div>
                                }
                                {
                                    secondCateId*1>0&&arrCateId.length>0&&arrCateId.map((item,index) => {
                                        if(item&&item.name&&item.name!== undefined)
                                        return (<div key={item.id} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleOptionClick}
                                                onDelClick={handleCateDelClick}
                                                text={item.name} isSmall={true} value={item.id}
                                            />
                                        </div>)
                                        
                                    })
                                }
                                {
                                    secondCateId*1>0&&arrFilter.length>0&&arrFilter.map((item,index) => {
                                        
                                        return (<div key={item} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleOptionClick}
                                                onDelClick={handleCateDelClick}
                                                text={item} isSmall={true} value={item}
                                            />
                                        </div>)
                                        
                                    })
                                }
                                {
                                    ((curPrice[0]*1===maxPrice[0]*1&&curPrice[1]*1===maxPrice[1]*1)||(curPrice[1]===0))&&<button className="default" onClick={()=>handleOpenPopup(0)}>가격</button> 
                                }
                                {
                                    secondCateId*1>0&&arrCateId.length===0&&arrFilter.length===0&&<button className="default" onClick={()=>handleOpenPopup(1)}>옵션</button> 
                                }
                                
                            </div>
                            </div>
                        }
                        <div className="product-select orderbox">
                                                        <MyEsOrderBox
                                                        options={Options}
                                                        placeholder=""
                                                        onChange={handlerChangeOrder}
                                                        valueDefault={getFilterOrderValue()}
                                                        height={'24px'} />
                                                    </div>
                    </CategoryFilterBlock>
                    <CategoryProductBlock ref={reflimit}>
                        <ProdItemListUlBlock>
                            {
                                // 상품 리스트 표시
                                prodItems&&prodItems.dataList.map((proditem) => {
                                    return (
                                        <ProdItem2 key={proditem._source.prdct_id}
                                            img={proditem._source.repr_img}
                                            prodname={proditem._source.prdct_nm}
                                            sale_price={proditem._source.sale_price}
                                            prdct_price={proditem._source.prdct_price}
                                            brandname={proditem._source.brnd_han}
                                            isBrandShow={curMenu === 'ct'}
                                            clickHandler={handleProdClick}
                                            brandid={proditem._source.brnd_id}
                                            prodinfo={proditem} />
                                    )
                                }
                                )
                            }
                            {isMobileOnly ? <li style={{height:'0px', margin: '0px', width:'44vw'}}></li> : ''}
                        </ProdItemListUlBlock>
                        <div className="paging-bottom"><PaginationMobile updatePageNum={handleChangePageNum} prodItems={prodItems} /></div>
                    </CategoryProductBlock>
            </CategoryContentsBlock>
            <CategoryPopBgContainer style={{display:popup? "block":'none'}}/>
            <CategoryPopContainer>
                <CateFilterPopup active={popup} handleClosePopup={handleClosePopup} pCate1Id={firstCateId} pCate2Id={secondCateId} pIndex={pIndex} handleReceiveFromPopup={handleReceiveFromPopup}
                _maxPrice={maxPrice} _curPrice={curPrice} brandId={[]} search=""/>
            </CategoryPopContainer>
            <CategoryPopBgContainer style={{display:popupCate? "block":'none'}}/>
            <CategoryPopContainer>
                <CategoryPopup active={popupCate} categoryInfo={categoryItems} handleClosePopup={handleCloseCatePopup} pCate1Id={firstCateId} pCate2Id={secondCateId} 
                handleReceiveFromPopup={handleReceiveFromCatePopup}/>
            </CategoryPopContainer>
            <Footer />
        </CategoryBlock>
        :
        <CategoryBlock>
            <Header />
            <CategoryContentsBlock className="clearfix">
                <CategoryLeftBlock>
                    <div className="title margin_b-30" onClick={handleCateAll}>카테고리</div>
                    {
                        categoryItems.map((curitem, idx) => {
                            return (
                                <CateAnimate key={idx} cateItem={curitem} active1stCateId={firstCateId} active2ndCateId={secondCateId} click1handler={click1handler} click2Handler={click2Handler}>
                                    
                                </CateAnimate>
                            );
                        })
                    }

                </CategoryLeftBlock>
                <CategoryRightBlock>
                    <CategoryBreadBlock display={firstCateId*1>0 ? "block" : "none"}>{getNavString()}</CategoryBreadBlock>
                    <CategoryFilterBlock>
                    {
                            isDefault?
                            <div className="rConatiner" width={"765px"}>
                            <div className="container clearfix" >
                                
                                <button className="default" onClick={()=>handleOpenPopup(0)}>가격</button> 
                                {
                                    secondCateId*1>0&&<button className="default" onClick={()=>handleOpenPopup(1)}>옵션</button> 
                                }
                            </div>
                            </div>
                            :
                            <div className="rConatiner" width={"765px"}>
                            <div className="container clearfix" >
                                {
                                    (curPrice[0]*1!==maxPrice[0]*1||curPrice[1]*1!==maxPrice[1]*1)&&curPrice[1]>0&&<div className="top-cate">
                                    <TagBtnMy
                                        active={true}
                                        float='left'
                                        onClick={handleOptionClick}
                                        onDelClick={handlePriceDelClick}
                                        text={Number(curPrice[0].toFixed(1)).toLocaleString()+'원~'+ Number(curPrice[1].toFixed(1)).toLocaleString()+'원'} isSmall={true} value={-10}
                                    />
                                    </div>
                                }
                                {
                                    secondCateId*1>0&&arrCateId.length>0&&arrCateId.map((item,index) => {
                                        if(item&&item.name&&item.name!== undefined)
                                        return (<div key={item.id} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleOptionClick}
                                                onDelClick={handleCateDelClick}
                                                text={item.name} isSmall={true} value={item.id}
                                            />
                                        </div>)
                                        
                                    })
                                }
                                {
                                    secondCateId*1>0&&arrFilter.length>0&&arrFilter.map((item,index) => {
                                        
                                        return (<div key={item} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleOptionClick}
                                                onDelClick={handleCateDelClick}
                                                text={item} isSmall={true} value={item}
                                            />
                                        </div>)
                                        
                                    })
                                }
                                {
                                    ((curPrice[0]*1===maxPrice[0]*1&&curPrice[1]*1===maxPrice[1]*1)||(curPrice[1]===0))&&<button className="default" onClick={()=>handleOpenPopup(0)}>가격</button> 
                                }
                                {
                                    secondCateId*1>0&&arrCateId.length===0&&arrFilter.length===0&&<button className="default" onClick={()=>handleOpenPopup(1)}>옵션</button> 
                                }
                                
                            </div>
                            </div>
                        }
                        <div className="product-select orderbox">
                                                        <MyEsOrderBox
                                                        options={Options}
                                                        placeholder=""
                                                        onChange={handlerChangeOrder}
                                                        valueDefault={getFilterOrderValue()}
                                                        height={'24px'} />
                                                    </div>
                    </CategoryFilterBlock>
                    <CategoryProductBlock>
                        <ProdItemListUlBlock>
                            {
                                // 상품 리스트 표시
                                prodItems&&prodItems.dataList.map((proditem) => {
                                    return (
                                        <ProdItem2 key={proditem._source.prdct_id}
                                            img={proditem._source.repr_img}
                                            prodname={proditem._source.prdct_nm}
                                            sale_price={proditem._source.sale_price}
                                            prdct_price={proditem._source.prdct_price}
                                            brandname={proditem._source.brnd_han}
                                            isBrandShow={curMenu === 'ct'}
                                            clickHandler={handleProdClick}
                                            brandid={proditem._source.brnd_id}
                                            prodinfo={proditem} />
                                    )
                                }
                                )
                            }
                        </ProdItemListUlBlock>
                        <div className="margin_t-20 paging-bottom"><Pagination updatePageNum={handleChangePageNum} prodItems={prodItems} /></div>
                    </CategoryProductBlock>
                </CategoryRightBlock>
            </CategoryContentsBlock>
            <CategoryPopBgContainer style={{display:popup? "block":'none'}}/>
            <CategoryPopContainer>
                <CateFilterPopup active={popup} handleClosePopup={handleClosePopup} pCate1Id={firstCateId} pCate2Id={secondCateId} pIndex={pIndex} handleReceiveFromPopup={handleReceiveFromPopup}
                _maxPrice={maxPrice} _curPrice={curPrice} brandId={[]} search=""/>
            </CategoryPopContainer>
            <Footer />
        </CategoryBlock>
    );
};

export default Category;
